import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage, getHeader, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const {
        pages: {
            productList: { isSearchPage },
        },
    } = state;

    return {
        view: state.pages.productList.view,
        searchWithinQueries: state.pages.productList.productFilters?.searchWithinQueries,
        productsDataView: getProductListDataView(state),
        isSearchPage,
        filterQuery: state.pages.productList.filterQuery,
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface ProductListColumnsStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnTableViewGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnTableViewGridItem?: GridItemProps;
}

export const columnsStyles: ProductListColumnsStyles = {
    container: {
        gap: 20,
    },
    leftColumnGridItem: {
        width: [12, 12, 3, 3, 3],
    },
    leftColumnTableViewGridItem: {
        width: [12, 12, 0, 0, 0],
    },
    rightColumnGridItem: {
        width: [12, 12, 9, 9, 9],
    },
    rightColumnTableViewGridItem: {
        width: 12,
    },
};

const styles = columnsStyles;

const ProductListColumns: FC<Props> = ({
    id,
    view,
    productsDataView,
    searchWithinQueries,
    isSearchPage,
    filterQuery,
}) => {
    const leftColumnGridItemStyle = view === "Table" ? styles.leftColumnTableViewGridItem : styles.leftColumnGridItem;
    const rightColumnGridItemStyle =
        view === "Table" ? styles.rightColumnTableViewGridItem : styles.rightColumnGridItem;

    const splittedQuery = filterQuery ? filterQuery?.split("&") : [];
    const filteredArr = splittedQuery?.filter(item => !item.startsWith("pageSize") && !item.startsWith("sort")) || [];

    if (
        !isSearchPage &&
        !searchWithinQueries &&
        (!productsDataView.value || productsDataView.value.length === 0) &&
        filteredArr.length === 0
    ) {
        return  <Zone contentId={id} zoneName="Content03" />;
    }

    return (
        <GridContainer {...styles.container}>
            <GridItem {...leftColumnGridItemStyle}>
                <Zone contentId={id} zoneName="Content00" />
            </GridItem>
            <GridItem {...rightColumnGridItemStyle}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListColumns),
    definition: {
        group: "Product List",
        displayName: "Columns",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
